import classNames from "classnames";
import { useState } from "react";

import styles from "./Media.module.css";

type PropTypes = {
  src: string;
  video?: boolean;
  controls?: boolean;
  full?: boolean;
  caption?: string;
  loop?: boolean;
};

const Media = ({ src, video = false, controls, full = false, caption, loop = false }: PropTypes) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onLoadStart = () => setIsLoading(true);

  const onCanPlay = () => {
    setIsLoading(false);
  };
  return (
    <div className={classNames(styles.media, { [styles.fullBleed]: full })}>
      {video ? (
        <figure>
          {isLoading ? <div className={classNames(styles.loading, styles.pulse)}>Loading...</div> : null}
          <div className={styles.mediaWrapper}>
            <video
              src={src}
              className={styles.video}
              onLoadStart={onLoadStart}
              onCanPlay={onCanPlay}
              controls={controls}
              autoPlay
              muted
              loop={loop}
              playsInline
            />
          </div>
          {caption ? <figcaption className={styles.caption}> {caption} </figcaption> : null}
        </figure>
      ) : (
        <figure>
          <div className={styles.mediaWrapper}>
            <img className={styles.image} src={src} alt={caption} />
            <figcaption className={styles.caption}> {caption} </figcaption>
          </div>
        </figure>
      )}
    </div>
  );
};

export default Media;
